/* @ngInject */
function StatusSelectController ($scope, $attrs, $timeout) {
  $scope.isOpen = false

  const api = {
    _handleClickAway,
    _handleSubtaskOptions
  }
  this.getApi = () => api

  activate()

  function activate () {
    if ($scope.isSubtask) api._handleSubtaskOptions()

    document.addEventListener('click', api._handleClickAway)
  }

  $scope.$on('$destroy', () => {
    document.removeEventListener('click', api._handleClickAway)
  })

  function _handleClickAway (ev) {
    const isClickOnComponent = $attrs.$$element[0].contains(ev.target)

    if (isClickOnComponent) return

    $timeout(() => {
      $scope.isOpen = false
    }, 0, true)
  }

  $scope.toggleDropdown = () => {
    if ($scope.readOnly) return

    $scope.isOpen = !$scope.isOpen
  }

  $scope.selectStatus = (status) => {
    $scope.value = status
    $scope.isOpen = false
    $scope.onChange(status)
  }

  function _handleSubtaskOptions () {
    $timeout(() => {
      $scope.options = ['INBOX', 'PROGRESS', 'DONE']
    }, 0, true)
  }
}

export { StatusSelectController }
